export default {
  altitudePreview: {
    expandAltitudeChart: 'Höhenprofil vergrößern',
    altitude: 'Höhe'
  }
}
